module.exports = __webpack_public_path__ + "static/media/coat.1f995a61.jpg";